import React from 'react';
import PropTypes from 'prop-types';

function IconProfile({ stroke, fill }) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
        id="avatar-1"
        className="customSVG"
        stroke={stroke}
        strokeWidth="3"
        fill={fill}
      >
        <path
          data-name="layer2"
          d="M24 40.8V44c0 2-1 5.2-11 7A13.4 13.4 0 0 0 2 62h60a15.5 15.5 0 0 0-12-11c-10-1.9-10-5-10-7v-3.2"
        />
        <path
          data-name="layer1"
          d="M46 25.6c0 10-6.3 18.4-14 18.4s-14-8-14-18v-9.6C18 6 25.4 2 32 2s14 3.6 14 14z"
        />
      </svg>
      <div
        className="d-flex d-lg-none justify-content-center align-items-center position-absolute translate-middle top-50 mt-2 me-2 bg-white text-dark navbar-icon-badge"
        style={{ width: '18px', height: '18px' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          fill="currentColor"
          className="bi bi-list"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
          />
        </svg>
      </div>
      <div
        className="d-none d-lg-flex justify-content-center align-items-center position-absolute translate-middle top-50 mt-2 bg-white text-dark navbar-icon-badge"
        style={{ width: '18px', height: '18px' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          fill="currentColor"
          className="bi bi-list"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
          />
        </svg>
      </div>
    </>
  );
}

IconProfile.propTypes = {
  stroke: PropTypes.string,
  fill: PropTypes.string,
};

IconProfile.defaultProps = {
  stroke: 'black',
  fill: 'none',
};

export default IconProfile;
